/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import {
    Heading,
    ContentContainerBodyShift,
    FlexRow,
    FlexCol,
    TextBlock,
    Text,
    Icon,
    IconName,
} from 'sarsaparilla';
import { lotteriesOnSiteText } from 'site-kit';

const items = [
    {
        copy: 'Provide fair access to those interested in competing for the recreation opportunity.',
        icon: 'key',
    },
    {
        copy: 'Support health and safety measures, including space restrictions.',
        icon: 'health-and-safety',
    },

    {
        copy: 'Prevent damage to the natural landscape.',
        icon: 'campground-host',
    },

    {
        copy: 'Preserve the visitor experience.',
        icon: 'thumb-up',
    },
];

export default function AboutLotteries() {
    return (
        <section id="about-lotteries" className="lottery-full-width-bg">
            <ContentContainerBodyShift>
                <FlexRow hasGutters={false}>
                    <FlexCol>
                        <Heading
                            headingLevel={2}
                            appearance="h3"
                            hasUnderline="left"
                            className="lottery-section-header"
                        >
                            About Lotteries
                        </Heading>
                        <TextBlock width="xl">
                            <Text size="lg" className="mb-3">
                                {lotteriesOnSiteText}
                            </Text>
                        </TextBlock>
                    </FlexCol>
                </FlexRow>
                <FlexRow className="lottery-about-blocks-wrap">
                    {items.map((item, index) => (
                        <FlexCol
                            className="lottery-about-blocks"
                            key={`lotAbout${index}`}
                        >
                            <div className="lottery-about-blocks-content" key={index}>
                                <Icon iconName={item.icon as IconName} />
                                <p>{item.copy}</p>
                            </div>
                        </FlexCol>
                    ))}
                </FlexRow>
            </ContentContainerBodyShift>
        </section>
    );
}
